"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Grid from "./webflow_modules/Layout/components/Grid";
import Heading from "./webflow_modules/Basic/components/Heading";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import Section from "./webflow_modules/Layout/components/Section";
import Span from "./webflow_modules/Basic/components/Span";
import * as _interactions from "./webflow_modules/interactions";
import { Communities } from "./Communities";
import { Footer } from "./Footer";
import { GlobalStyles } from "./GlobalStyles";
import { Navbar } from "./Navbar";
import { NavMarketListRowContainer } from "./NavMarketListRowContainer";
import { NavToggleState } from "./NavToggleState";
import { SearchInputHomePage } from "./SearchInputHomePage";

const _interactionsData = JSON.parse(
  '{"events":{"e-123":{"id":"e-123","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-41","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-124"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a69085","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a69085","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1707853020650},"e-125":{"id":"e-125","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-41","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-126"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a6908f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a6908f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1707853020650}},"actionLists":{"a-41":{"id":"a-41","title":"Hero Modal [open]","actionItemGroups":[{"actionItems":[{"id":"a-41-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":"none"}},{"id":"a-41-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-41-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":"flex"}},{"id":"a-41-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1707139287082}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function PageComponentLocations({
  mapSlot = "",
  searchInputSlot,
  stateCollapseSlot = "",
  stateListSlot = "",
  toggleSearchButtonProps = {},
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <Block tag={"div"}>
      <GlobalStyles />
      <Block className={"page-wrapper"} tag={"div"}>
        <Navbar />
        <Block className={"main-wrapper"} id={"main-content"} tag={"main"}>
          <Block className={"header"} tag={"header"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-small"} tag={"div"}>
                <Block className={"header30_content"} tag={"div"}>
                  <Block className={"padding-section-large"} tag={"div"}>
                    <Block className={"text-align-center"} tag={"div"}>
                      <Heading className={"text-color-white"} tag={"h1"}>
                        {"Love Where You Live"}
                      </Heading>
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Block>
            <Block className={"header30_background-image-wrapper"} tag={"div"}>
              <Block className={"image-overlay-layer"} tag={"div"} />
              <Image
                alt={""}
                className={"header30_background-image"}
                // @ts-ignore - User-defined custom attribute(s)
                fetchPriority={"high"}
                height={"auto"}
                loading={"eager"}
                src={
                  "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657cb27ed2af154a6fa9d108_Rectangle%2086.jpg"
                }
                width={"auto"}
              />
            </Block>
          </Block>
          <Section className={"map"} tag={"section"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-large"} tag={"div"}>
                <Block className={"padding-section-large"} tag={"div"}>
                  <Grid className={"header2_component-copy"} tag={"div"}>
                    <Block className={"header2_content-copy"} tag={"div"}>
                      <Block
                        className={"margin-bottom margin-small"}
                        tag={"div"}
                      >
                        <Heading className={"heading-5"} tag={"h2"}>
                          {"Experience "}
                          <br />
                          <Span className={"text-color-blue"}>
                            {"elevated living"}
                          </Span>
                        </Heading>
                      </Block>
                      <Block className={"div-block-90"} tag={"div"}>
                        <Paragraph className={"max-width-small-copy"}>
                          {
                            "Spanning numerous locations, we're committed to matching you with the perfect blend of comfort, style, and community, ensuring your search for a new home ends with us."
                          }
                        </Paragraph>
                      </Block>
                      <Block className={"margin-top margin-medium"} tag={"div"}>
                        <Link
                          block={"inline"}
                          button={false}
                          className={"link-block-5"}
                          options={{
                            href: "#",
                          }}
                          {...toggleSearchButtonProps}
                        >
                          <Block
                            className={"fake-form-on-locations-page"}
                            tag={"div"}
                          >
                            <Block
                              className={"seach-frame-container-copy"}
                              tag={"div"}
                            >
                              <Block className={"text-field-fake"} tag={"div"}>
                                {"Search for a home"}
                              </Block>
                            </Block>
                            <Block
                              className={"fake-submit-button-on-locations-page"}
                              tag={"div"}
                            >
                              <Block tag={"div"}>{"Search"}</Block>
                            </Block>
                          </Block>
                        </Link>
                        <Block className={"hero_modal-trigger"} tag={"div"} />
                        <Block
                          className={"search_modal___opacity-_0-hide-me"}
                          tag={"div"}
                        >
                          <Block
                            className={"search_modal-close-button"}
                            tag={"div"}
                            {...toggleSearchButtonProps}
                          >
                            <HtmlEmbed
                              className={"html-embed-4"}
                              content={
                                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>'
                              }
                            />
                          </Block>
                          <Block
                            className={"search_modal-close-trigger"}
                            tag={"div"}
                            {...toggleSearchButtonProps}
                          />
                          <Block
                            className={"search-input-slot-container"}
                            tag={"div"}
                          >
                            {searchInputSlot ?? (
                              <SearchInputHomePage
                                showClear={true}
                                showPopover={true}
                              />
                            )}
                          </Block>
                          <Link
                            block={"inline"}
                            button={false}
                            className={"search-modal-close-button"}
                            options={{
                              href: "#",
                            }}
                            {...toggleSearchButtonProps}
                          >
                            <Block className={"div-block-106"} tag={"div"}>
                              <HtmlEmbed
                                className={"search-modal-close-icon"}
                                content={
                                  '<!--<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>\n-->\n<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">\n  <path fill="currentColor" d="M345 137l17-17L328 86.1l-17 17-119 119L73 103l-17-17L22.1 120l17 17 119 119L39 375l-17 17L56 425.9l17-17 119-119L311 409l17 17L361.9 392l-17-17-119-119L345 137z"/></svg>'
                                }
                              />
                              <Block className={"text-block-15"} tag={"div"}>
                                {"Close"}
                              </Block>
                            </Block>
                          </Link>
                        </Block>
                      </Block>
                    </Block>
                    <Block
                      className={"div-block-43"}
                      id={
                        "w-node-a8f1e31d-4500-778e-0401-125178d2290d-78d228e3"
                      }
                      tag={"div"}
                    >
                      <Block className={"map-wrapper"} tag={"div"}>
                        <Block className={"div-block-82"} tag={"div"}>
                          {mapSlot ?? (
                            <>
                              <HtmlEmbed
                                className={"html-embed"}
                                content={
                                  '<div id="map" width="1200" height="739"></div>'
                                }
                              />
                              <Image
                                alt={""}
                                className={"image-18"}
                                height={"auto"}
                                loading={"lazy"}
                                src={
                                  "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65d10ac514a8e354f1328e0a_Map.png"
                                }
                                width={"auto"}
                              />
                            </>
                          )}
                        </Block>
                      </Block>
                    </Block>
                  </Grid>
                </Block>
              </Block>
            </Block>
          </Section>
          <Communities />
          <Section className={"text_component"} tag={"section"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-large"} tag={"div"}>
                <Block className={"padding-section-large"} tag={"div"}>
                  <Grid className={"header49_component"} tag={"div"}>
                    <Block className={"header49_content-left"} tag={"div"}>
                      <Heading tag={"h2"}>{"Our Caring Approach"}</Heading>
                    </Block>
                    <Block className={"header49_content-right"} tag={"div"}>
                      <Paragraph>
                        {
                          "Dedicated to making life comfortable for our residents since 1993, we offer a wide range of communities in the best neighborhoods throughout Arizona, California, Colorado, Nevada, Texas, and Washington. Our award-winning management team takes pride in creating positive living experiences for everyone in our lively communities."
                        }
                      </Paragraph>
                    </Block>
                  </Grid>
                </Block>
              </Block>
            </Block>
          </Section>
          <Section className={"text_component-copy"} tag={"section"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-medium"} tag={"div"}>
                <Block className={"padding-section-large"} tag={"div"}>
                  <Block
                    className={"nav-market-list-section-container"}
                    tag={"div"}
                  >
                    <Block className={"margin-bottom margin-large"} tag={"div"}>
                      <Block className={"text-align-center"} tag={"div"}>
                        <Heading tag={"h2"}>
                          {"All Our "}
                          <Span className={"text-color-blue"}>
                            {"Locations"}
                          </Span>
                        </Heading>
                      </Block>
                    </Block>
                    <Block
                      className={"nav-market-list-section-container"}
                      tag={"div"}
                    >
                      {stateListSlot ?? (
                        <>
                          <NavMarketListRowContainer text={"adfsaf"} />
                          <NavMarketListRowContainer text={"California"} />
                          <NavMarketListRowContainer text={"Colorado"} />
                          <NavMarketListRowContainer text={"Nevada"} />
                          <NavMarketListRowContainer text={"Texas"} />
                          <NavMarketListRowContainer text={"Washington"} />
                        </>
                      )}
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Block>
          </Section>
          <Section className={"text_component-copy"} tag={"section"}>
            <Block tag={"div"}>
              {stateCollapseSlot ?? (
                <>
                  <NavToggleState text={"Arizona"} />
                  <NavToggleState text={"CAlifornia"} />
                  <NavToggleState />
                  <NavToggleState />
                </>
              )}
            </Block>
          </Section>
        </Block>
        <Footer />
      </Block>
    </Block>
  );
}
